import { Col, Row } from 'antd'
import Specifications from 'app/components/Core/PurchasingRequestItem/Specifications'
import Button from 'app/components/UI-Elements/Controls/buttons/Button'
import { Routes } from 'app/constants/Routes'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { filterByPendingServiceRequests, selectedParentItem } from '../Helpers/filters'
import ProductName from './ProductName'

const Header: React.FC<MemberProps<IPurchasingRequest>> = ({ member: purchasingRequest }) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()

  const onDamageClick = () => {
    navigate(Routes.PurchasingRequest.member(String(purchasingRequest.id)).finalize)
  }

  const onServiceRequestClick = () => {
    navigate(Routes.PurchasingRequest.member(String(purchasingRequest.id)).service_request)
  }

  const openServiceRequests = purchasingRequest.product_request_items.filter(
    filterByPendingServiceRequests
  )
  const machines = purchasingRequest.product_request_items?.filter(selectedParentItem) || []

  return (
    <Row gutter={[0, 24]}>
      <If condition={openServiceRequests.length > 0}>
        <Col span={24}>
          <h5 className="text-black mb-0">
            {formatMessage({ id: 'purchasing-request.show.open-service-request-title' })}
          </h5>
        </Col>
        <Col span={24}>
          <Row align="middle">
            <Col span={16}>
              <p>
                {formatMessage({ id: 'purchasing-request.show.open-service-request-description' })}
              </p>
            </Col>
            <Col span={8} className="text-right">
              <Button onClick={onServiceRequestClick}>{formatMessage({ id: 'answer' })}</Button>
            </Col>
          </Row>
        </Col>
      </If>
      <If condition={!purchasingRequest.add_on}>
        <Col span={24}>
          <h5 className="text-black mb-0">{formatMessage({ id: 'rental-show-action-title' })}</h5>
        </Col>
        <Col span={24}>
          <Row align="middle">
            <Col span={16}>{formatMessage({ id: 'rental-show-action-description' })}</Col>
            <Col span={8} className="text-right">
              <Button
                onClick={onDamageClick}
                type="secondary"
                title={formatMessage({ id: 'rental-show-action-button-title' })}
              />
            </Col>
          </Row>
        </Col>
      </If>
      <Col span={24}>
        <h5 className="text-black mb-0">
          {formatMessage({
            id: purchasingRequest.add_on
              ? 'rental-show-services-title'
              : 'rental-show-machines-title'
          })}
        </h5>
      </Col>
      <Col span={24}>
        <Row gutter={[10, 10]}>
          {machines.map((requestItem) => (
            <>
              <Col span={24} key={requestItem.id}>
                <ProductName member={requestItem} />
              </Col>
              <If condition={purchasingRequest.add_on && !!requestItem.item.quantity}>
                <Col span={24} className="pl-4">
                  <span className="text-gray">
                    {formatMessage(
                      { id: 'rental-show-requested-quantity' },
                      { quantity: requestItem.item.quantity, unit: requestItem.item.unit }
                    )}
                  </span>
                </Col>
              </If>
              <If condition={requestItem.item.specifications?.length}>
                <Col span={24} className="pl-4">
                  <Specifications member={requestItem.item} />
                </Col>
              </If>
            </>
          ))}
        </Row>
      </Col>
    </Row>
  )
}

export default Header
